import { booleanType, someType, functionType, stringType, anyType, objectType, } from '../_util/type';
export const progressStatuses = ['normal', 'exception', 'active', 'success'];
const ProgressType = ['line', 'circle', 'dashboard'];
const ProgressSize = ['default', 'small'];
export const progressProps = () => ({
    prefixCls: String,
    type: stringType(),
    percent: Number,
    format: functionType(),
    status: stringType(),
    showInfo: booleanType(),
    strokeWidth: Number,
    strokeLinecap: stringType(),
    strokeColor: anyType(),
    trailColor: String,
    /** Alias of `trailColor` (antd ≥ 5.23). */
    railColor: String,
    /** @deprecated Use `size` instead */
    width: Number,
    success: objectType(),
    gapDegree: Number,
    gapPosition: stringType(),
    /** Alias of `gapPosition` (antd ≥ 5.23). */
    gapPlacement: stringType(),
    size: someType([String, Number, Array, Object]),
    steps: someType([Number, Object]),
    /** Line progress value position (antd ≥ 5.18). */
    percentPosition: objectType(),
    /** Custom rounding for step count (antd ≥ 5.24). Default `Math.round`. */
    rounding: functionType(),
    /** @deprecated Use `success` instead */
    successPercent: Number,
    title: String,
    progressStatus: stringType(),
});
